<!-- Develop this div appropriately -->
<div class="container">
    <div class="table">
        <div class="table-header">
            <div class="td-mail">
                <span>Email</span>
            </div>
            <div class="td-active">
                <span>Active</span>
            </div>
            <div class="td-desig">
                <span>Designation</span>
            </div>
        </div>
        <div class="spacer-height">

        </div>
        <div class="table-container">
            <button *ngFor="let employee of employee | paginate: { itemsPerPage: 10, currentPage: 1 }; let i = index;"
                class="table-body" (click)="buttonPressed()">
                <div class="td-mail">
                    <span>{{employee.email}}</span>
                </div>
                <div class="td-active">
                    <!-- <span>{{employee.name}}</span> -->
                    <span>active</span>
                </div>
                <div class="td-desig">
                    <!-- <span>{{employee.phone_no}}</span> -->
                    <span>Conductor</span>
                </div>
            </button>
            <div *ngIf="noData" id="noData" class= "table-body">
                <span>No Matching Results</span>
            </div>
        </div>

    </div>
</div>